import { useEffect, useMemo, useReducer } from "react";
import WorkbookStore from "../../../Flux/Stores/WorkbookStore";
import { COLUMNS } from "../../../Components/ShowHideColumns";

export default function useColumns({ metaData, campaignTMEnabled, clientTMEnabled, gcmStatus, platformSyncStatus, auditLevels }) {
	const [enabledColumns, setEnabledColumns] = useReducer(() => {
		return WorkbookStore.getEnabledColumns();
	}, []);

	const columns = useMemo(() => {
		const isPrisma = metaData.PlatformName == "Mediaocean (OX)/Prisma";

		let extraColumns = [];
		if (clientTMEnabled) {
			if (!isPrisma) {
				// if not prisma, show the main TM columns with no extra logic checks
				extraColumns = [...COLUMNS.TRAFFIC_MANAGER, COLUMNS.DO_NOT_USE];
			} else {
				// otherwise, check if TM is enabled at the campaign level
				if (campaignTMEnabled) {
					extraColumns = [...extraColumns, ...COLUMNS.TRAFFIC_MANAGER, COLUMNS.DO_NOT_USE];
				}

				// check if the master campaign is synced. if so, show the prisma related columns.
				if (platformSyncStatus) {
					const externalStatus = metaData?.ExternalSystemStatusID;
					extraColumns = [
						...extraColumns,
						...COLUMNS.PRISMA.map(({ id, name }) => ({
							id,
							name,
							selected: !(externalStatus !== 1 ? false : Boolean(platformSyncStatus && externalStatus == 1))
						}))
					];
				}
			}
		}

		// Display the column in both GCM and Prisma campaigns
		if (gcmStatus && [1, 5].includes(metaData.PlatformID)) {
			extraColumns = [...extraColumns, COLUMNS.GOOGLE_PLACEMENT_ID, ...COLUMNS.GOOGLE_CAMPAIGN_MANAGER];
		}

		// check user preferences for show/hide
		const auditLevel = auditLevels.find(({ AuditLevelName }) => AuditLevelName == "Placement")?.AuditLevelID;
		const Preferences = enabledColumns?.find(({ HierarchyLevelID }) => HierarchyLevelID == auditLevel)?.Preferences;
		const parsedPreferences = Preferences ? JSON.parse(Preferences) : null;

		if (parsedPreferences && parsedPreferences instanceof Object) {
			extraColumns = extraColumns.map(({ id, name, selected }) => ({
				id,
				name,
				selected: parsedPreferences[id] ?? selected
			}));
		}

		extraColumns = [...extraColumns, COLUMNS.IsDraft];

		return extraColumns;
	}, [enabledColumns, clientTMEnabled, campaignTMEnabled, gcmStatus, platformSyncStatus]);

	useEffect(() => {
		WorkbookStore.on("enabled_columns_fetched", setEnabledColumns);
		WorkbookStore.on("traffic_manager_toggled", setEnabledColumns);

		return () => {
			WorkbookStore.removeListener("enabled_columns_fetched", setEnabledColumns);
			WorkbookStore.removeListener("traffic_manager_toggled", setEnabledColumns);
		};
	}, []);

	return columns;
}
